import * as React from 'react'

import IconButton           from '@material-ui/core/IconButton'
import Tooltip              from '@material-ui/core/Tooltip'
import Logout               from '@material-ui/icons/PowerSettingsNew'
import { FormattedMessage } from 'react-intl'

import logout          from '../../project-utils/hard-logout'
import testingHooks    from '../../testing-hooks'
import { ClickPrompt } from '../atoms'

const LogoutTool = () => (
  <Tooltip
    title={
      <FormattedMessage
        id={'tooltip.logout'}
        defaultMessage={'Logout'}
      />
    }
  >
    <ClickPrompt
      header={(
        <FormattedMessage id={'generic.sureYouWantToLogout'} />
      )}
    >
      <IconButton
        data-test-id={testingHooks.tools.logout}
        onClick={logout}
        color={'inherit'}
      >
        <Logout />
      </IconButton>
    </ClickPrompt>
  </Tooltip>
)

export default LogoutTool



// WEBPACK FOOTER //
// ./src/components/molecules/LogoutTool.tsx